export function openPopup(): void {
    document.getElementById("popupoverlay")?.classList.remove("hidden");
    document.getElementById("popupform")?.classList.remove("hidden");
    document.getElementById("popupbutton")?.classList.add("hidden");
}

export function closePopup():void {
    document.getElementById("popupoverlay")?.classList.add("hidden");
    document.getElementById("popupform")?.classList.add("hidden");
    document.getElementById("popupbutton")?.classList.remove("hidden");
}